import { useState } from "react";
import { Box } from "@mui/material";
import AdminDrawer from "../AdminDrawer";
import { DRAWER_PERMANENT_BP, DRAWER_RAIL, DRAWER_WIDTH } from "../AdminDrawer/widths";
import Header from "../Header";
import { useAuth } from "../../providers/AuthProvider";

export default function Layout({ children }) {
    const { user } = useAuth();
    const [isVisible, setIsVisible] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    const handleVisibilityChange = () => {
        setIsVisible((open) => !open);
    };

    if (!user) {
        return children;
    }

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#F6F5F1",
                transition: "margin-left .25s ease",
                ml: {
                    xs: 0,
                    [DRAWER_PERMANENT_BP]: `${isExpanded ? DRAWER_WIDTH : DRAWER_RAIL}px`,
                },
                pt: "80px",
                px: { xs: 2, md: 3 },
                pb: 3,
            }}
        >
            <Header handleVisibilityChange={handleVisibilityChange} isExpanded={isExpanded} />
            <AdminDrawer
                isVisible={isVisible}
                handleVisibilityChange={handleVisibilityChange}
                onExpandChange={setIsExpanded}
            />
            {children}
        </Box>
    );
}